import { CustomerTile } from "../components/CustomerTile"

export function BuddyDetailsMembers(){
	return (
		<>
		<p>No members assigned to buddy/</p>
			{/* <CustomerTile />
			<CustomerTile />
			<CustomerTile /> */}
		</>
	)
}